import Question from './Question'

export default Question



// WEBPACK FOOTER //
// ./src/components/Question/index.js